import(/* webpackMode: "eager" */ "/home/ec2-user/reyner.giovanni/one21-company-site/production/current/src/app/global-error.js")